import { useState, useEffect } from 'react';
import { Mail, Clock, CheckCircle } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminContacts() {
  const [contacts, setContacts] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/admin/contacts`);
        setContacts(res.data.contacts);
        setTotal(res.data.total);
      } catch (err) {}
      setLoading(false);
    };
    fetch();
  }, []);

  return (
    <div>
      <h1 className="font-heading text-3xl text-white mb-8" data-testid="admin-contacts-title">Contact Messages ({total})</h1>

      {loading ? (
        <div className="text-center py-12 text-slate-500">Loading...</div>
      ) : contacts.length === 0 ? (
        <div className="glass rounded-2xl p-12 text-center">
          <Mail className="mx-auto mb-4 text-slate-500" size={40} />
          <p className="text-slate-400">No contact messages yet</p>
        </div>
      ) : (
        <div className="space-y-4">
          {contacts.map(c => (
            <div key={c.id} className="glass rounded-2xl p-5" data-testid={`contact-${c.id}`}>
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h3 className="text-white font-medium">{c.name}</h3>
                  <p className="text-cyan text-sm">{c.email}</p>
                </div>
                <div className="flex items-center gap-2 text-xs text-slate-500">
                  <Clock size={12} />
                  {new Date(c.created_at).toLocaleString()}
                </div>
              </div>
              {c.subject && <p className="text-slate-300 text-sm font-medium mb-2">{c.subject}</p>}
              <p className="text-slate-400 text-sm leading-relaxed">{c.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
